class Navigation {
	init() {
		this.toggleMobileNav();
		this.toggleMobileNavItems();
		this.toggleNavScrolling();
	}

	toggleNavScrolling() {
		const header = document.querySelector('.main-header');
		if (!header) return;
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						header.classList.remove('active');
					} else {
						header.classList.add('active');
					}
				});
			},
			{ threshold: [1.0] }
		);

		// Create an invisible div for the observer to watch
		const invisibleMarker = document.createElement('div');
		invisibleMarker.style.position = 'absolute';
		invisibleMarker.style.top = '0px';
		invisibleMarker.style.height = '1px';
		invisibleMarker.style.width = '100%';
		invisibleMarker.style.visibility = 'hidden';
		invisibleMarker.style.pointerEvents = 'none';
		document.body.appendChild(invisibleMarker);

		observer.observe(invisibleMarker);
	}
	toggleMobileNav() {
		const menuToggle = document.querySelector('[data-toggle-menu]');

		menuToggle?.addEventListener('click', function (e) {
			e.preventDefault();
			if (!(e.target instanceof HTMLElement)) {
				return;
			}
			if (document.body.classList.contains('open-nav')) {
				document.body.classList.remove('open-nav');
				e.target.setAttribute('aria-expanded', 'false');
				e.target.setAttribute('title', 'Open main menu');
			} else {
				document.body.classList.add('open-nav');
				e.target.setAttribute('aria-expanded', 'true');
				e.target.setAttribute('title', 'Close main menu');
			}
		});
	}

	toggleMobileNavItems() {
		const menuItems = document.querySelectorAll('.main-menu .menu-item-has-children > a');
		menuItems.forEach((menuItem) => {
			menuItem.addEventListener('click', function (e) {
				if (
					!menuItem.parentElement?.parentElement?.classList.contains('main-menu') ||
					window.matchMedia('(max-width: 992px)').matches
				) {
					e.preventDefault();
				}
				const menuItemParent = menuItem.parentElement;
				if (!(e.target instanceof HTMLElement) || !menuItemParent) {
					return;
				}
				if (menuItemParent.classList.contains('open-menu')) {
					menuItemParent.classList.remove('open-menu');
					e.target.setAttribute('aria-expanded', 'false');
					e.target.setAttribute('title', 'Open main menu');
				} else {
					menuItemParent.classList.add('open-menu');
					e.target.setAttribute('aria-expanded', 'true');
					e.target.setAttribute('title', 'Close main menu');
				}
			});
		});
	}
}

export default new Navigation();
